export default [
  "#5470c6",
  "#91cc75",
  "#fac858",
  "#ee6666",
  "#73c0de",
  "#3ba272",
  "#fc8452",
  "#9a60b4",
  "#ea7ccc",
  "#7e57c2",
  "#ffa726",
  "#26a69a",
  "#ff7043",
  "#78909c",
  "#42a5f5",
  "#c2185b",
  "#4164d6",
  "#66bb6a",
  "#26c6da",
  "#446392",
  "#e64a19",
  "#fbc02d",
  "#8d6e63",
  "#1976d2",
  "#ec407a",
  "#0097a7",
  "#f57c00",
  "#00796b",
  "#5c6bc0",
  "#e26168",
  "#29b6f6",
  "#ffee58",
];
